const faceImgtext = ['[拜拜]','[鄙视]','[打电话]','[打哈欠]','[大哭]','[大笑]','[得意]','[点赞]','[愤怒]','[鼓掌]','[嘿哈]','[滑稽]','[欢迎]','[奸笑]','[沮丧]','[开心]','[可伶]','[流汗]','[卖萌]','[破涕为笑]','[敲打]','[胜利]','[调皮]','[无语]','[捏脸]','[抱抱]','[摊手]','[比心]','[便便]','[加油]','[礼物]','[哈士奇]','[成交]','[心碎]','[月亮]'];
const faceImgArray = [];
for(let i = 1;i < faceImgtext.length;i++){
    faceImgArray.push({
        alt:faceImgtext[i],
        src: require('../../Common/images/gif/face/53c_min_'+ (i+1) +'.gif'),
    })
}
export default faceImgArray;